import Login from "./components/Login/Login.jsx";
import SiteStatus from "./components/SiteStatus/SiteStatus";

const rootPath = process.env.PUBLIC_URL;

//  拿掉  exact 避免 LIFF 白畫面
const routes = [
  {
    path: `/login`,
    component: Login,
  },

  {
    path: `/site-status`,
    component: SiteStatus,
  },
  {
    path: `/*`,
    component: Login,
  },
];

export default routes;
export { rootPath };
